
import { mapGetters } from 'vuex';

// Api
import * as apiAuthentication from '../api/public/authentication';

import errorsMixin from '../mixins/error-handler';

// libraries
import { emailIsWellFormatted } from '../libraries/utils';

export default {
  name: 'AccountLost',
  mixins: [errorsMixin],
  data() {
    return {
      emailIsWellFormatted,
      fieldsRefs: ['account_lost-email', 'account_lost-form'],
      email: null,
      expiration: null,
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      getIsMobile: 'screen/getIsMobile',
    }),
  },
  watch: {
    email() {
      // When the email changes, if it is not set or if it is valid, set the error to false
      if (!this.email || emailIsWellFormatted(this.email)) {
        this.errors$.handleError(false, 'account_lost', 'email');
      }
    },
  },
  mounted() {
    if (!this.getIsMobile) {
      this.$refs['account_lost-email'].focus();
    }
  },
  methods: {
    recovery() {
      // prevalidation
      this.errors$.reset();
      this.errors$.handleError(!emailIsWellFormatted(this.email), 'account_lost', 'email', 'is_email');
      if (this.errors$.hasErrors()) {
        this.errors$.focusFirstError();
        return;
      }

      this.loading = true;
      apiAuthentication.recovery({ email: this.email }, this)
        .then((res) => {
          const options = { hour: '2-digit', minute: '2-digit' };
          this.expiration = new Date(res.expirated_at).toLocaleDateString('fr-FR', options);
        }).catch((error) => {
          // Validation error
          if (error.response && error.response.status === 400) {
            if (this.errors$.hasErrors()) {
              this.errors$.focusFirstError();
              return;
            }
            this.errors$.handleError(true, 'account_lost', 'form');
            this.$nextTick(() => {
              this.$refs['account_lost-form'].$el.scrollIntoView({ behavior: 'smooth', block: 'center' });
            });
          }
        }).finally(() => {
          this.loading = false;
        });
    },
  },
};
